import { memo } from 'react';

import { EyeOutlinedSize16, IconDynamic } from '@hh.ru/magritte-ui/icon';
import Text, { TextImportance } from 'bloko/blocks/text';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import BlokoIconReplaceContainer from 'src/components/BlokoIconReplaceContainer';
import translation from 'src/components/translation';

interface RegionItemLabelProps {
    isBackofficeRegion: boolean;
    text: string;
}

const TrlKeys = {
    hint: 'employer.price.resume-access.anotherRegion.popupHiddenItem',
};

const RegionItemLabel: TranslatedComponent<RegionItemLabelProps> = ({ isBackofficeRegion, text, trls }) =>
    isBackofficeRegion ? (
        <Text importance={TextImportance.Tertiary}>
            <IconDynamic title={trls[TrlKeys.hint]}>
                <BlokoIconReplaceContainer>
                    <EyeOutlinedSize16 initialColor="secondary" />
                </BlokoIconReplaceContainer>{' '}
            </IconDynamic>
            {text}
        </Text>
    ) : (
        <>{text}</>
    );

export default memo(translation(RegionItemLabel));
